import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { IGeneralProps } from "types";
import { ITalentInvites } from "features/invites/types";

export const QUERY_KEY_FOR_TALENT_JOB_FOR_RECRUITER =
  "talent-job-invites-for-recruiter";

// const getSingleFolder = async (
//   props: IGeneralProps
// ): Promise<ITalentInvites[]> => {
//   const id = props.id;
//   const url = `${END_POINT.BASE_URL}/v1/talent-job-invites-for-recruiter/${id}`;
//   const config = {
//     headers: {
//       Accept: "application/json",
//       Authorization: `Bearer ${props.token}`,
//     },
//   };

//   const res = await axios.get(url, config);
//   const data: ITalentInvites[] = res.data.data.map((item: ITalentInvites) => ({
//     ...item,
//   }));
//   return data;
// };

const getSingleFolder = async (
  props: IGeneralProps
): Promise<ITalentInvites[]> => {
  const {
    id,
    token,
    location_country,
    location_city,
    title,
    gender,
    visibility_score,
    skills,
    experience_level,
    relocate,
    sector,
  } = props;

  const params = new URLSearchParams();

  if (location_country) params.append("location_country", location_country);
  if (location_city) params.append("location_city", location_city);
  if (title) params.append("title", title);
  if (gender) params.append("gender", gender);
  if (visibility_score)
    params.append("visibility_score", String(visibility_score));
  if (skills) params.append("skills", skills);
  if (experience_level) params.append("experience_level", experience_level);
  // if (relocate) params.append("relocate", relocate);
  if (sector) params.append("sector", String(sector));

  const url = `${
    END_POINT.BASE_URL
  }/v1/talent-job-invites-for-recruiter/${id}?${params.toString()}`;
console.log("Fetching folder from:", url);

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.get(url, config);

  const data: ITalentInvites[] = res.data.data.map((item: ITalentInvites) => ({
    ...item,
  }));

  return data;
};

export const useGetRecruiterInvites = ({ id, token }: IGeneralProps) => {
  const queryData = useQuery([QUERY_KEY_FOR_TALENT_JOB_FOR_RECRUITER, id], () =>
    getSingleFolder({
      id,
      token,
    })
  );

  return queryData;
};
